export default __webpack_public_path__ + "83cbefc324702da62ffdb6867894d1ef.jpeg";